import { useEffect, useState } from "react";
import { BlockStack, Box, InlineStack, Text, TextField } from "@shopify/polaris";
import supabase from "../../supabase-client";

// Search a fleet car by plate or VIN. Returns the car row (id, plate, year,
// model) — always a real `cars` row, never free text.
const safeLike = (s) => s.replace(/[,()%*\\]/g, " ").trim();

export default function CarPicker({ onPick, label = "Auto", autoFocus = false }) {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);

  useEffect(() => {
    const q = safeLike(query);
    if (q.length < 2) return setResults([]);
    const t = setTimeout(async () => {
      const { data } = await supabase
        .from("cars")
        .select("id, plate, vin, year, model:car_models(name)")
        .or(`plate.ilike.%${q}%,vin.ilike.%${q}%`)
        .order("active", { ascending: false })
        .limit(6);
      setResults(data || []);
    }, 250);
    return () => clearTimeout(t);
  }, [query]);

  return (
    <BlockStack gap="100">
      <TextField
        label={label}
        value={query}
        onChange={setQuery}
        placeholder="Placa o VIN"
        autoComplete="off"
        focused={autoFocus}
        clearButton
        onClearButtonClick={() => setQuery("")}
      />
      {results.map((c) => (
        <Box key={c.id} padding="200" borderWidth="025" borderColor="border" borderRadius="200">
          <div
            role="button"
            tabIndex={0}
            style={{ cursor: "pointer" }}
            onClick={() => onPick(c)}
            onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onPick(c)}
          >
            <InlineStack gap="200" blockAlign="center">
              <Text fontWeight="semibold">{c.plate || "Sin placa"}</Text>
              <Text tone="subdued">
                {[c.model?.name, c.year].filter(Boolean).join(" ")} · {c.vin?.slice(-6)}
              </Text>
            </InlineStack>
          </div>
        </Box>
      ))}
    </BlockStack>
  );
}
